import React, { useEffect, useRef } from "react";
import { withStyles } from "@material-ui/core/styles";
import cx from "classnames";
import Cookies from "js-cookie";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { logEvents } from "../../redux/commonActions";
import {
  addToolTipToStore,
  getToolTipPriority,
  removeToolTipFromStore
} from "../../utils/tooltiphelper";

const styles = theme => ({
  root: {
    position: "absolute",
    zIndex: 1
  },
  toolTipParent: {
    visibility: "hidden"
  },
  closeImg: {
    ["@media (max-width:576px)"]: { height: "9px", width: "12px" },
    cursor: "pointer"
  },
  close: {
    display: "flex",
    justifyContent: "flex-end"
  }
});

const NewToolTip = props => {
  const {
    rootClass,
    children,
    classes,
    tipClass,
    tipUrl = "/hire/tip.svg",
    showTip = false,
    keepScrollEvent = true,
    keepOutsideClickEvent = true,
    setCookie = false,
    cookieKey = "",
    isClose = true,
    priority
  } = props;
  const toolTipRef = useRef(null);

  const handleCloseWrapper = () => {
    const { handleClose } = props;
    if (setCookie) {
      const subscriberElement = document.querySelector(`.${cookieKey}`);
      if (subscriberElement?.style?.visibility === "visible") {
        removeToolTipFromStore({ id: `${cookieKey}` });
        handleClose();
      }
    } else {
      handleClose();
    }
  };

  const handleClickOutside = event => {
    if (
      toolTipRef &&
      toolTipRef.current &&
      !toolTipRef.current.contains(event.target)
    ) {
      handleCloseWrapper();
    }
  };

  useEffect(() => {
    const { eventName, logEvents, expiry = 365 } = props;
    if (eventName) {
      logEvents(eventName);
    }
    if (setCookie)
      addToolTipToStore({
        id: `${cookieKey}`,
        priority: priority || getToolTipPriority(`${cookieKey}`),
        expiry: expiry
      });
    if (keepOutsideClickEvent)
      document.addEventListener("mousedown", handleClickOutside);
    if (keepScrollEvent) window.addEventListener("scroll", handleCloseWrapper);
    return () => {
      if (keepScrollEvent)
        window.removeEventListener("scroll", handleCloseWrapper);
      if (keepOutsideClickEvent)
        document.removeEventListener("mousedown", handleClickOutside);
      if (setCookie) removeToolTipFromStore({ id: `${cookieKey}` });
    };
  }, []);
  return (
    <div
      className={cx(setCookie ? classes.toolTipParent : null, `${cookieKey}`)}
    >
      <div className={cx(classes.root, rootClass)} ref={toolTipRef}>
        {isClose ? (
          <div className={classes.close}>
            <img
              src="/hire/close.svg"
              alt="close"
              height={12}
              width={12}
              className={classes.closeImg}
              onClick={handleCloseWrapper}
            />
          </div>
        ) : null}

        {children}
      </div>
      {showTip && (
        <img
          src={tipUrl}
          className={tipClass}
          height={18}
          width={18}
          alt="tip"
        />
      )}
    </div>
  );
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators({ logEvents }, dispatch);
};

export default connect(
  null,
  mapDispatchToProps
)(withStyles(styles)(NewToolTip));
